import { decode } from 'html-entities';

import { DotBlockEditor } from '../shared/decodeTextBlock';
import customRenderers from '../block-editor';
import LinkNoPrefetch from '../link-noprefetch';
import DotImage from '../block-editor/dotImage';

function Heading(props) {
    if (!props.node?.content) {
        return null;
    }
    const [{ text }] = props.node.content;
    const HeadingTag = `h${props.node.attrs?.level || 3}`;
    return (
        <HeadingTag
            className="dark:text-white"
            style={{
                textAlign: props.node.attrs?.textAlign || 'left'
            }}>
            {decode(text)}
        </HeadingTag>
    );
}

function Paragraph(node) {
    const {
        node: { content }
    } = node;
    if (!content || content.length === 0) {
        return null;
    }

    const renderContent = (item, index) => {
        if (item.type === 'hardBreak') {
            return <br key={index} />;
        }

        if (item.type === 'text' && item.text !== undefined) {
            let element = decode(item.text);

            // Apply marks in reverse order (outermost first)
            if (item.marks && Array.isArray(item.marks) && item.marks.length > 0) {
                [...item.marks].reverse().forEach((mark) => {
                    switch (mark.type) {
                        case 'bold':
                            element = <strong>{element}</strong>;
                            break;
                        case 'italic':
                            element = <em>{element}</em>;
                            break;
                        case 'underline':
                            element = <u>{element}</u>;
                            break;
                        case 'strike':
                            element = <s>{element}</s>;
                            break;
                        case 'superscript':
                            element = <sup>{element}</sup>;
                            break;
                        case 'subscript':
                            element = <sub>{element}</sub>;
                            break;
                        case 'link':
                            element = (
                                <LinkNoPrefetch href={mark.attrs?.href}>{element}</LinkNoPrefetch>
                            );
                            break;
                        default:
                            element = <span>{element}</span>;
                    }
                });
            }

            return <span key={index}>{element}</span>;
        }

        return null;
    };

    return (
        <p className="dark:text-white">
            {content.map((item, index) => renderContent(item, index))}
        </p>
    );
}

function WebPageContent({ body }) {
    return (
        <DotBlockEditor
            blocks={body}
            className="!container prose !px-0"
            customRenderers={{
                ...customRenderers,
                heading: Heading,
                paragraph: Paragraph,
                dotImage: DotImage
            }}
        />
    );
}

export default WebPageContent;
